'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.patchPrecheckFailed = exports.operationBlocked = exports.hostOffline = exports.vdiInUse = exports.objectAlreadyExists = exports.notSupportedDuringUpgrade = exports.vmLacksFeature = exports.vmBadPowerState = exports.vmIsTemplate = exports.vmMissingPvDrivers = exports.invalidParameters = exports.serverUnreachable = exports.authenticationFailed = exports.noHostsAvailable = exports.forbiddenOperation = exports.invalidCredentials = exports.unauthorized = exports.noSuchObject = exports.notImplemented = undefined;

var _iteratee2 = require('lodash/iteratee');

var _iteratee3 = _interopRequireDefault(_iteratee2);

var _isArray2 = require('lodash/isArray');

var _isArray3 = _interopRequireDefault(_isArray2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _makeError = require('make-error');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var XoError = function (_BaseError) {
  _inherits(XoError, _BaseError);

  function XoError(_ref) {
    var code = _ref.code,
        message = _ref.message,
        data = _ref.data;

    _classCallCheck(this, XoError);

    var _this = _possibleConstructorReturn(this, (XoError.__proto__ || Object.getPrototypeOf(XoError)).call(this, message));

    _this.code = code;
    _this.data = data;
    return _this;
  }

  _createClass(XoError, [{
    key: 'toJsonRpcError',
    value: function toJsonRpcError() {
      return {
        message: this.message,
        code: this.code,
        data: this.data
      };
    }
  }]);

  return XoError;
}(_makeError.BaseError);

var create = function create(code, getProps) {
  var factory = function factory(args) {
    return new XoError(_extends({}, getProps(args), { code: code }));
  };
  factory.is = function (error, predicate) {
    return error.code === code && (0, _iteratee3.default)(predicate)(error);
  };

  return factory;
};

// =============================================================================

var notImplemented = exports.notImplemented = create(0, function () {
  return {
    message: 'not implemented'
  };
});

var noSuchObject = exports.noSuchObject = create(1, function (id, type) {
  return {
    data: { id: id, type: type },
    message: 'no such object'
  };
});

var unauthorized = exports.unauthorized = create(2, function () {
  return {
    message: 'not authenticated or not enough permissions'
  };
});

var invalidCredentials = exports.invalidCredentials = create(3, function () {
  return {
    message: 'invalid credentials'
  };
});

// Deprecated alreadyAuthenticated (4)

var forbiddenOperation = exports.forbiddenOperation = create(5, function (operation, reason) {
  return {
    data: { operation: operation, reason: reason },
    message: 'forbidden operation: ' + operation
  };
});

// Deprecated GenericError (6)

var noHostsAvailable = exports.noHostsAvailable = create(7, function () {
  return {
    message: 'no hosts available'
  };
});

var authenticationFailed = exports.authenticationFailed = create(8, function () {
  return {
    message: 'authentication failed'
  };
});

var serverUnreachable = exports.serverUnreachable = create(9, function (objectId) {
  return {
    data: {
      objectId: objectId
    },
    message: 'server unreachable'
  };
});

var invalidParameters = exports.invalidParameters = create(10, function (message, errors) {
  if ((0, _isArray3.default)(message)) {
    errors = message;
    message = undefined;
  }

  return {
    data: { errors: errors },
    message: message || 'invalid parameters'
  };
});

var vmMissingPvDrivers = exports.vmMissingPvDrivers = create(11, function (_ref2) {
  var vm = _ref2.vm;
  return {
    data: {
      objectId: vm
    },
    message: 'missing PV drivers'
  };
});

var vmIsTemplate = exports.vmIsTemplate = create(12, function (_ref3) {
  var vm = _ref3.vm;
  return {
    data: {
      objectId: vm
    },
    message: 'VM is a template'
  };
});

// TODO: We should probably create a more generic error which gathers all incorrect state errors.
// e.g.:
// incorrectState {
//   data: {
//     objectId: 'af43e227-3deb-4822-a79b-968825de72eb',
//     property: 'power_state',
//     actual: 'Running',
//     expected: 'Halted'
//   },
//   message: 'incorrect state'
// }
var vmBadPowerState = exports.vmBadPowerState = create(13, function (_ref4) {
  var vm = _ref4.vm,
      expected = _ref4.expected,
      actual = _ref4.actual;
  return {
    data: {
      objectId: vm,
      expected: expected,
      actual: actual
    },
    message: 'VM state is ' + actual + ' but should be ' + expected
  };
});

var vmLacksFeature = exports.vmLacksFeature = create(14, function (_ref5) {
  var vm = _ref5.vm,
      feature = _ref5.feature;
  return {
    data: {
      objectId: vm,
      feature: feature
    },
    message: 'VM lacks feature ' + (feature || '')
  };
});

var notSupportedDuringUpgrade = exports.notSupportedDuringUpgrade = create(15, function () {
  return {
    message: 'not supported during upgrade'
  };
});

var objectAlreadyExists = exports.objectAlreadyExists = create(16, function (_ref6) {
  var objectId = _ref6.objectId,
      objectType = _ref6.objectType;
  return {
    data: {
      objectId: objectId,
      objectType: objectType
    },
    message: (objectType || 'object') + ' already exists'
  };
});

var vdiInUse = exports.vdiInUse = create(17, function (_ref7) {
  var vdi = _ref7.vdi,
      operation = _ref7.operation;
  return {
    data: {
      objectId: vdi,
      operation: operation
    },
    message: 'VDI in use'
  };
});

var hostOffline = exports.hostOffline = create(18, function (_ref8) {
  var host = _ref8.host;
  return {
    data: {
      objectId: host
    },
    message: 'host offline'
  };
});

var operationBlocked = exports.operationBlocked = create(19, function (_ref9) {
  var objectId = _ref9.objectId,
      code = _ref9.code;
  return {
    data: {
      objectId: objectId,
      code: code
    },
    message: 'operation blocked'
  };
});

var patchPrecheckFailed = exports.patchPrecheckFailed = create(20, function (_ref10) {
  var errorType = _ref10.errorType,
      patch = _ref10.patch;
  return {
    data: {
      objectId: patch,
      errorType: errorType
    },
    message: 'patch precheck failed: ' + errorType
  };
});
//# sourceMappingURL=api-errors.js.map